const redirect404 = () => {
  window.location.href = `${process.env.TK_HOST}/404`;

  return null;
};

export default redirect404;
